import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-optional-note-field',
  imports: [CommonModule],
  templateUrl: './optional-note-field.component.html',
  styleUrl: './optional-note-field.component.scss',
})
export class OptionalNoteFieldComponent implements OnChanges {
  @Input() variant: 'default' | 'inline' = 'default';
  @Input() label = 'Notas';
  @Input() buttonLabel = 'Agregar nota';
  @Input() placeholder = 'Escribe una nota opcional';
  @Input() value = '';
  @Input() rows = 2;
  @Input() iconOnly = false;
  @Input() iconClass = 'fa-solid fa-note-sticky';

  @Output() valueChange = new EventEmitter<string>();

  expanded = false;

  get isActive(): boolean {
    return this.expanded || this.value.trim().length > 0;
  }

  @HostBinding('class.is-expanded')
  get isExpandedClass(): boolean {
    return this.expanded;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('value' in changes && this.value.trim().length > 0) {
      this.expanded = true;
    }
  }

  open(): void {
    this.expanded = true;
  }

  toggle(): void {
    this.expanded = !this.expanded;
  }

  clear(): void {
    this.expanded = false;
    this.valueChange.emit('');
  }

  onInput(event: Event): void {
    const nextValue = (event.target as HTMLTextAreaElement | null)?.value ?? '';
    this.valueChange.emit(nextValue);
  }
}

